// extracted by mini-css-extract-plugin
module.exports = {"section":"asdrSection-module--section--2N65g","name":"asdrSection-module--name--HgJfI","image":"asdrSection-module--image--33Tx2","reverse":"asdrSection-module--reverse--1l2jd"};